module.exports = __webpack_public_path__ + "img/banner5.32100e6.png";